import dayjs from 'dayjs';

import { flattenNodeFrontmatterArrayIfRequired } from './gatsby';

export const getNumberOfUpcomingAppointments = (coursesEdges) =>
	coursesEdges
		.map(({ node: course }) => course.frontmatter.appointments.filter(isFutureAppointment))
		.flat().length;

export const getCoursesOfCourseType = (courseTypeSlug, courseEdges) => {
	allCoursesHavePropertyOrThrow(courseEdges, 'courseType');
	return courseEdges.filter(({ node: { frontmatter: c } }) => c.courseType === courseTypeSlug);
};

export const sortAppointments = (appointments) =>
	appointments.sort((a, b) => dayjs(a.start).diff(dayjs(b.start)));

export const isFutureAppointment = (appointment) => dayjs(appointment.start).isAfter(dayjs());

export const findCourseByUuid = (courses, uuid) => {
	const flattenedCourses = flattenNodeFrontmatterArrayIfRequired(courses);
	return flattenedCourses.find((c) => c.uuid === uuid);
};

export const orderCourses = (args) => {
	const { courses, courseTypes, coursesOrderEntries } = args;
	if (!courses || courses.length === 0) {
		return [];
	}

	const flattenedCourses = flattenNodeFrontmatterArrayIfRequired(courses);
	allCoursesHavePropertyOrThrow(courses, 'courseType');

	if (!coursesOrderEntries || coursesOrderEntries.length === 0) {
		return flattenedCourses;
	}

	const courseUuids = flattenedCourses.map((c) => c.uuid);
	const courseTypeUuid = courseTypes.find(
		({ node: { frontmatter: ct } }) => ct.slug === flattenedCourses[0].courseType,
	).node.frontmatter.uuid;

	const uuidExistsInCoursesOrder = coursesOrderEntries.some((c) => c.courseType === courseTypeUuid);
	if (!uuidExistsInCoursesOrder) return flattenedCourses;

	const coursesOfGivenCourseType = coursesOrderEntries.filter(
		(c) => c.courseType === courseTypeUuid,
	);

	// if there is no order specified for this courseType, just return the courses as is
	if ((coursesOfGivenCourseType[0].courses?.length ?? 0) === 0) return flattenedCourses;

	return (
		coursesOfGivenCourseType
			// get courseUuids
			.map((c) => c.courses)[0]
			// only courses for this courseType
			.filter((courseUuid) => courseUuids.includes(courseUuid))
			// map back to actual course
			.map((courseUuid) => findCourseByUuid(courses, courseUuid))
	);
};

export const allCoursesHavePropertyOrThrow = (courses, propertyName) => {
	if (!flattenNodeFrontmatterArrayIfRequired(courses).every((c) => !!c[propertyName])) {
		const coursesWithoutProperty = courses.filter((c) => !c[propertyName]);
		throw Error(
			`${coursesWithoutProperty.length} out of ${courses.length} courses do not have property ${propertyName}.`,
		);
	}
};
